// DS8.2.1 Simple Footer
import React from 'react';
import type { BiEvent } from '@wix/da-bi/pkg/events';
import c from 'classnames';
import BrandedButton from '../../Buttons/BrandedButton';
import { sanitizeHref } from "@wix/da-url";

import s from './PopoverSimpleFooter.scss';

interface Props {
  message?: React.ReactNode;
  label?: string;
  biData?: BiEvent;
  href?: string;
  onClick?: () => void;
}

const PopoverSimpleFooter: React.FC<Props> = ({
  message,
  label,
  biData,
  href,
  onClick,
}) => {
  return (
    <div className={c(s['root'])}>
      {message && <div className={s['message']}>{message}</div>}
      {label && (
        <BrandedButton
          size="medium"
          variant="brand-green"
          onClick={onClick}
          fillContainerWidth
          biData={biData}
          href={sanitizeHref(href)}
          className={s['button']}
        >
          {label}
        </BrandedButton>
      )}
    </div>
  );
};
PopoverSimpleFooter.displayName = 'PopoverSimpleFooter';

export default PopoverSimpleFooter;
